import { GET, POST, PUT, DELETE } from "../../api";

export const findAll = async () => {
  return await GET(`/admin/dashboard`);
};

export const findAllSideBar = async () => {
  return await GET(`/admin/dashboard/sidebar`);
};
